import React, { useMemo } from "react";
import { computeWordDiff } from "../lib/diff";

// Renders a Word-style track-changes view between two pieces of text:
//   removed words  -> red, struck through
//   added words    -> green, underlined
//   unchanged words-> normal
const WordDiff = ({ oldText = "", newText = "", className = "" }) => {
  const diff = useMemo(() => computeWordDiff(oldText, newText), [oldText, newText]);

  return (
    <div
      className={`whitespace-pre-wrap leading-relaxed text-sm ${className}`}
      data-testid="word-diff"
    >
      {diff.map((seg, idx) => {
        if (seg.type === "added") {
          return (
            <span
              key={idx}
              className="underline decoration-2 text-[#3d4f22] dark:text-[#b8cf88] bg-[#d8e5b8]/60 dark:bg-[#556B2F]/30 rounded px-0.5"
            >
              {seg.text}{" "}
            </span>
          );
        }
        if (seg.type === "removed") {
          return (
            <span
              key={idx}
              className="line-through text-red-600 dark:text-red-400 bg-red-100/60 dark:bg-red-900/30 rounded px-0.5"
            >
              {seg.text}{" "}
            </span>
          );
        }
        return (
          <span key={idx} className="text-slate-700 dark:text-slate-300">
            {seg.text}{" "}
          </span>
        );
      })}
    </div>
  );
};

export default WordDiff;
